import { combineReducers } from 'redux';

import filterReducer from './components/FiltersV2/redux/reducer';
import orderByReducer from './components/OrderByV2/redux/reducer';
import searchReducer from './components/SearchLanding/redux/reducer';
import paginationReducer from './Pagination/ducks';

const rootReducer = combineReducers({
  filters: filterReducer,
  orderBy: orderByReducer,
  pagination: paginationReducer,
  search: searchReducer,
  tracks: (state = {}) => state,
  user: (state = {}) => state,
  banners: (state = {}) => state,
  categoriesBanners: (state = {}) => state,
  organization: (state = {}) => state,
  countryPrefix: (state = '') => state,
  userLanguage: (state = '') => state,
  // dummy reducers for categories/softwares urls
  categories: (state = {}) => state,
  softwares: (state = {}) => state,
  translations: (state = {}) => state,
  currentLanguage: (state = {}) => state,
  // This key is not used in catalog, it is only necessary to remove the redux warning `Unexpected key "colorTheme" found in preloadedState argument...`
  // In the SSR we are passing all keys from initial state to redux, that's why we get a warn about unexpected keys
  colorTheme: (state = {}) => state,
});

export default rootReducer;
